import { siteInfo } from '@/mocks/homeData';

export default function Hero() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/30"></div>

      <div className="relative w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 max-w-[1280px] mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-primary-100/80 text-primary-700 px-3 py-1.5 rounded-full text-xs font-medium mb-5">
              <i className="ri-fire-line"></i>
              <span>{siteInfo.tagline}</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-4">
              黑料吃瓜
              <span className="block text-2xl md:text-3xl lg:text-4xl text-primary-500 mt-1">
                全网爆料资讯聚合平台
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[600px] mx-auto lg:mx-0 mb-6">
              黑料吃瓜网是行业领先的娱乐资讯聚合平台，每日汇集全网最新爆料、明星八卦、网红热点与社会话题。我们以"快、准、全"为运营理念，7×24小时不间断更新，确保用户第一时间获取最热门的吃瓜内容。无论你是资深吃瓜群众还是偶尔围观的路人，黑料吃瓜都是你不可错过的资讯入口。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              {siteInfo.heroStats.map((stat) => (
                <div key={stat.label} className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                  <span className="text-sm text-foreground-600">{stat.label}</span>
                  <span className="text-sm font-bold text-foreground-900">{stat.value}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                onClick={(e) => { e.preventDefault(); handleNavClick('#updates'); }}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                立即浏览最新爆料
              </a>
              <a
                href="#topics"
                onClick={(e) => { e.preventDefault(); handleNavClick('#topics'); }}
                className="w-full sm:w-auto px-8 py-3 border-2 border-background-300 text-foreground-700 font-semibold rounded-lg hover:border-primary-300 hover:text-primary-500 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                探索热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20editorial%20newsroom%20scene%20with%20warm%20ambient%20lighting%20and%20clean%20minimalist%20aesthetic%2C%20featuring%20abstract%20geometric%20shapes%20in%20warm%20orange%20and%20cream%20tones%20representing%20breaking%20news%20and%20information%20flow%2C%20sophisticated%20magazine%20layout%20style%20composition%20with%20soft%20shadows%20and%20organic%20textures%2C%20editorial%20photography%20with%20high%20detail%20and%20harmonious%20warm%20color%20palette&width=800&height=600&seq=hero-main-visual&orientation=landscape"
                alt="黑料吃瓜官网入口 - 最新爆料资讯聚合平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}